import BigCubeimg from '../assets/images/BigCube2.png'

const BigCube = () =>{
	return(
	<></>
	)
}

export default BigCube;